export default "__VITE_ASSET__Daml0Gaq__"